// Rekit uses a new approach to organizing actions and reducers. That is
// putting related actions and reducers in one file. See more at:
// https://medium.com/@nate_wang/a-new-approach-for-managing-redux-actions-91c26ce8b5da

import {
  HOME_SET_FILTER,
} from './constants';


export function setFilter(filterId, item, value) {
  return {
    type: HOME_SET_FILTER,
    data: {filterId, item, value}
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case HOME_SET_FILTER:
      return {
        ...state,
        filterables: {...state.filterables, 
          [action.data.filterId]: 
          {
             ...state.filterables[action.data.filterId],
            [action.data.item]: action.data.value
          }
          
          }
      };

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/features/home/redux/setFilter.js